export const SUPPORT_PHONE_DISPLAY = "+91 73030 94613";
export const SUPPORT_PHONE_TEL = "+917303094613";